import React from 'react'
import { Router, Head } from 'react-static'
import Routes from 'react-static-routes'

const App = () => (
  <div>
    <Head titleTemplate="%s | Makuch Roofing">
      <meta charSet="utf-8" />
    </Head>
    <Router>
      <Routes />
    </Router>
  </div>
)

export default App



// WEBPACK FOOTER //
// /opt/build/repo/src/components/App.js